/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AbsenceType } from "common/types/Configuration";

import { ConfigurationState, AuthConfig } from "./types";
import { configurationApi } from "./api";

export const initialState = {
    absenceTypes: [] as AbsenceType[],
    shiftsConfig: {
        isEnabledViewingClaimableShifts: false,
        isEnabledClaimShift: false,
        isEnabledUnclaimShift: false,
        isEnabledRequestAbsence: false,
        isDisplayRatesEnabled: false,
        hoursConstraints: {},
    },
    currencyCode: "USD",
} as ConfigurationState;

export const configurationSlice = createSlice({
    initialState,
    name: "configuration",
    reducers: {
        setBaseApiUrl: (state, action: PayloadAction<string>) => {
            state.baseApiUrl = action.payload ?? "";
        },
        setClientRegion: (state, action: PayloadAction<string>) => {
            state.clientRegion = action.payload;
        },
        setTenantId: (state, action: PayloadAction<string>) => {
            state.tenantId = action.payload;
        },
        setClaimDate: (state, action: PayloadAction<Date>) => {
            state.claimDate = action.payload;
        },
        setAuthToken: (state, action: PayloadAction<string>) => {
            state.authToken = action.payload;
        },
        setIsDriverApp: (state, action: PayloadAction<boolean>) => {
            state.isDriverApp = action.payload;
        },
        setAuthConfiguration: (state, action: PayloadAction<AuthConfig>) => {
            state.authConfiguration = action.payload;
        },
        setDrmDriver: (state, action: PayloadAction<{ id: string }>) => {
            state.drmDriver = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            configurationApi.endpoints.getConfiguration.matchFulfilled,
            (state, { payload }) => {
                return {
                    ...state,
                    ...payload,
                    isTaaS: !payload.serviceTags?.includes("internal"),
                };
            }
        );
    },
});

// Reducer
export default configurationSlice.reducer;
